<template>
  <ReferenceComponentParentList
    :searchList="result"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    @onClick="onItemSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
      >
        Backlog
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <div :class="['reference-item', `is-${option.itemTypeParsed?.id.toLowerCase()}`]">
        <div class="reference-item__header">
          <BaseSubHeading
            weight="500"
            size="medium"
            color="monochrome-06"
          >
            #{{ option.sequenceNumber }}
          </BaseSubHeading>

          <span
            :class="['reference-item__status', `is_${option.statusParsed?.id.toLowerCase()}`]"
            >{{ option.statusParsed?.label }}</span
          >
        </div>
        <BaseSubHeading
          size="small"
          weight="500"
          color="monochrome-05"
          darkColor="monochrome-07"
          className="reference-item__body"
        >
          {{ option.title }}
        </BaseSubHeading>
      </div>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Action } from "s-vuex-class"

import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { FilterSearchItem, Item, ServerResponse } from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions } from "@/store"
import { parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList
}

@Options({
  name: "ItemList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Action(Actions.SEARCH_ITEM) findItems: (
    filter: FilterSearchItem
  ) => Promise<ServerResponse<Item>>

  componentType = ReferenceType.ITEM
  waitTitle = "reference.search.item"
  result: Item[] = []
  isLast = true

  async created() {
    this.filter = new FilterSearchItem()
    this.filter.addSort("sequenceNumber", true)
    this.filter.projectIds = [this.projectId]
    this.searchAction = this.onSearchItems
  }

  queryUpdated(q) {
    this.filter.page = 1
    const query = (q ?? "").toString()
    this.filter.q = query.trim()
    this.search()
  }

  onItemSelected(payload) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }

  async onSearchItems() {
    const serverResponse = await this.findItems(this.filter)
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }
}
</script>
